import script from "./SwordDesk.vue?vue&type=script&setup=true&lang=js"
export * from "./SwordDesk.vue?vue&type=script&setup=true&lang=js"

import "./SwordDesk.vue?vue&type=style&index=0&id=49403011&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49403011"]])

export default __exports__